import cn from 'classnames';
import React__default from 'react';
import { Tabs } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';
import { generateKeyFromTab } from '@sravni/ugc/lib/specialOffers/helpers';
import { generateHeadingTitle } from '../../helpers/generateHeadingTitle.js';
import { getTabTitleTo, getTabTitle } from '../../helpers/getTitle.js';
import modules_31ab199a from './Headings.module.scss.js';

const HorizontalHeading = ({ element, tabs, onTabChange, activeTabType, horizontalText, showOneHorizontalTabHeading = false, }) => {
    const isMobile = useIsMobile();
    const headingText = horizontalText
        ? horizontalText
        : `${generateHeadingTitle(activeTabType)} ${getTabTitleTo(activeTabType)}`;
    const heading = React__default.cloneElement(element, { className: cn('h-mb-20', element.props.className) }, headingText);
    if (!showOneHorizontalTabHeading && tabs.length === 1) {
        return heading;
    }
    const handleTabChange = (key) => {
        onTabChange(tabs[key]);
    };
    return (React__default.createElement(React__default.Fragment, null,
        heading,
        React__default.createElement(Tabs, { onChange: handleTabChange, className: isMobile ? 'h-mb-20' : 'h-mb-24', key: JSON.stringify(tabs) }, tabs.map(tab => {
            return (React__default.createElement(Tabs.TabPane, { key: generateKeyFromTab(tab), title: getTabTitle(tab), className: modules_31ab199a.tabPane }));
        }))));
};

export { HorizontalHeading };
//# sourceMappingURL=HorizontalHeading.js.map
